import { t } from 'i18next'
import React, { useCallback, useMemo } from 'react'
import { ContentStateProperty, OnChangeValue, ScreenProperty } from '../../../../@types/types'
import Datepicker from './Datepicker'
import { ScreenName } from '../../../../services/domain/wizardScreens'

export interface SimpleDatepickerProps {
  id: string
  propertyName: ContentStateProperty
  screen: ScreenName
  errors: string[]
  labelTranslationKey: string
  selectedDate?: Date
  wrapperClassName?: string
  onChange: (screenProperty: ScreenProperty, value: OnChangeValue) => void
}

const SimpleDatepicker: React.FC<SimpleDatepickerProps> = ({
  id,
  propertyName,
  labelTranslationKey,
  selectedDate,
  screen,
  errors,
  wrapperClassName = 'grid-item one-whole margin-top-l',
  onChange,
}) => {
  const minDate = useMemo(() => new Date(), [])
  const onChange1 = useCallback(
    (name: ContentStateProperty, value: OnChangeValue) =>
      onChange(
        {
          screen,
          property: name,
        },
        value
      ),
    [onChange, screen]
  )
  return (
    <div className={wrapperClassName}>
      <Datepicker
        id={id}
        propertyName={propertyName}
        errors={errors}
        selectedDate={selectedDate}
        minDate={minDate}
        labelTranslationKey={labelTranslationKey}
        placeholder={t('wizard.date', 'Date')}
        onChange={onChange1}
      />
    </div>
  )
}

export default SimpleDatepicker
